import { WindowLocation } from '@reach/router';
import { ParsedQuery, parse } from 'query-string';

// When redirecting inside our own app, we sometimes use reach router's navigate and sometimes window.location
// (The former is the default; the latter we use to pass information from Cogsworth to local dev environment via the preview environment)
// Depending on which of those we do, query params can be passed either in URL query or in router location.state.search
// This here encapsulates the two cases and can be used instead of parse(useLocation())
export function useRedirectQuery(location: WindowLocation): ParsedQuery<string> | undefined {
	if (location.search.length > 0) {
		return parse(location.search);
	} else if (
		location.state === Object(location.state) &&
		typeof (location.state as Record<string, any>).search === 'string'
	) {
		return parse((location.state as { search: string }).search);
	} else {
		return;
	}
}
